import { generateGoogleReCaptchaScriptSrc as h } from "./generateGoogleReCaptchaScriptSrc.js";
const S = ({
  onload: c,
  appendTo: o = "head",
  isEnterprise: r = !1,
  host: n,
  render: p,
  badge: i,
  hl: a,
  ...s
}) => {
  const d = h({
    host: n,
    isEnterprise: r,
    render: p,
    hl: a,
    badge: i
  }), t = document.createElement("script");
  Object.entries(s).forEach(([g, e]) => {
    t.setAttribute(g, (e == null ? void 0 : e.toString()) ?? "");
  }), t.src = d, t.onload = c, document[o].appendChild(t);
};
export {
  S as injectGoogleReCaptchaScript
};
//# sourceMappingURL=injectGoogleReCaptchaScript.js.map
